import React, { Component, PropTypes } from 'react'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import container from '../../helpers/container'

const Styles = require('./PlanScorecardRedirect.css')

@CSSModules(Styles, {allowMultiple:true})
export default class PlanScorecardRedirect extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  render() {
    const title = 'Apple'
    const description = 'See how Apple\'s is rated on environmental and social sustainability issues.'
    const url = config.domain + config.routes.plans + '/apple'

    this.context.router.push(config.routes.plans + '/apple?li=1')
    //
    return (
      <div styleName='main'>
        {container.helmet(title, description, url)}
        <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={false}/>
      </div>
    )
  }
}
